// extracted by mini-css-extract-plugin
export var standaloneTable = "_ft-0";
export var withExtraHeader = "_ft-1";